package ui.showcase.showcases

import csstype.PropertiesBuilder
import emotion.react.css
import helpers.isPhone
import react.FC
import react.Props
import react.dom.html.ReactHTML
import ru.malygin.myConst.UrlLocal
import ui.pages.Footer
import utils.tech.TextWithUrls
import web.cssom.*
import web.window.WindowTarget
import web.window.window

val MorePage = FC{
    val testList = MorePageHelp().urlPairList
    val isPhone = isPhone()

    ReactHTML.div{

        ReactHTML.div {
            css {
                maxWidth = 1433.px
                width = 100.pct
                display = Display.inlineGrid
            }
            testList.forEachIndexed { indexMain, item ->

                TwiceBlockItem{
                    index = indexMain
                    textBlock = item.text
                    imageBlock = if (isPhone) null else item.image
                    urls = item.urls
                    important = item.important
                    customProperties = {
                        it.minHeight = item.minHeight
                    }
                    customImgCss = {
                        it.scale = item.scale.unsafeCast<Scale>()
                        it.transformOrigin = item.transformOrigin
                        if (indexMain != testList.size-1) {
                            it.padding = 10.px
                        }
                    }
                }
            }
        }


        Footer()
    }
}

private external interface TwiceBlockItemProps : Props {
    var index: Int
    var textBlock: String
    var imageBlock: String?
    var urls: List<UrlLocal>
    var important: Boolean
    var customProperties:(PropertiesBuilder) -> Unit
    var customImgCss: (PropertiesBuilder) -> Unit
}

private val TwiceBlockItem = FC<TwiceBlockItemProps>{props ->
    val index = props.index.takeIf { it!= undefined }
    val textBlock = props.textBlock.takeIf { it!= undefined }
    val imageBlock = props.imageBlock.takeIf { it!= undefined }
    val urls = props.urls.takeIf { it!= undefined }!!
    val important = props.important.takeIf { it!= undefined } ?: false
    val customProperties = props.customProperties.takeIf { it!= undefined } ?: {}
    val customImgCss = props.customImgCss.takeIf { it!= undefined } ?: {}

    var customBorderLength = 20.px
    val customBorderRadius = "20px 20px 20px 20px".unsafeCast<BorderRadius>()
    val imgMarginVertical = 5.px

    val width1: Percentage
    val width2: Percentage
    if (imageBlock != null) {
        width1 = 70.pct
        width2 = 30.pct
    }else{
        width1 = 100.pct
        width2 = 0.pct
    }

    ReactHTML.div{
        className = ClassName("more_page_item_container")
        css(className) {
            customProperties(this)

            display = Display.flex
            justifyContent = JustifyContent.center
            alignItems = AlignItems.center
            margin = Margin(vertical = 10.px, horizontal = 20.px)
            if (important){
                border = Border(
                    width = 3.px,
                    style = LineStyle.solid,
                    color = Color("red")
                )
            }
            borderRadius = customBorderLength
        }

        ReactHTML.div{
            css(className) {
                width = width1
            }
            ReactHTML.div{
                TextWithUrls(
                    textBlock, urls,
                    cssPlusText = {
                        it.textShadow = TextShadow(
                            offsetX = 0.px,
                            offsetY = 0.px,
                            blurRadius = 20.px,
                            color = Color("black"),
                        )
                    }
                ).giveMeText().invoke()
            }
        }
        imageBlock?.let {img->
            ReactHTML.div{
                className = ClassName("more_page_item_container_image_container")
                css(className) {
                    width = width2
                    borderRadius = customBorderRadius
                    margin = Margin(
                        top = 10.px,
                        right = 35.px,
                        bottom = 10.px,
                        left = 0.px,
                    )
                }


                ReactHTML.div{
                    ReactHTML.img{
                        css(className) {
                            customImgCss(this)
                            width = 100.pct
                            maxHeight = 200.px
                            objectFit = ObjectFit.scaleDown
                            display = Display.block
                            cursor = Cursor.pointer
//                            borderRadius = customBorderRadius
                        }
                        onClick = {
                            window.open(urls.first().url, WindowTarget._blank)
                        }
                        src = img
                        alt = img.split("/").lastOrNull() ?: "_I_"
                    }
                }
            }
        }
    }
}

private class MorePageHelp {
    private val textForMakeBy = """
    Сервис разработал Малыгин Иван, студент ПРК
    """.trimIndent()

    private val textForOffSite = """
    Официальный сайт ГБПОУ "Пермский радиотехнический колледж им. А.С. Попова"
    """.trimIndent()

    private val textForHosting = """
    Хостин сервиса размещен на Timeweb
    """.trimIndent()

    private val textForAndroidApp = """
        Вы также можете попробовать мобильное приложение для Android
    """.trimIndent()

    private val textForTechHelp = """
        Если у вас возникли какие-либо проблемы или предложения по улучшению сервиса, пожалуйста, свяжитесь с нами. (vanya.malygin@vk.com)
    """.trimIndent()

    private val urlsForMakeBy = listOf(
        UrlLocal(
            text = "ПРК",
            url ="https://prk.perm.ru/",
        )
    )

    private val urlsForOffSite = listOf(
        UrlLocal(
            text = "ГБПОУ \"Пермский радиотехнический колледж им. А.С. Попова\"" ,
            url = "https://prk.perm.ru/",
        )
    )

    private val urlsForHosting = listOf(
        UrlLocal(
            text = "Timeweb" ,
            url = "https://timeweb.cloud/r/ebunein",
        )
    )
    private val urlsForAndroidApp = listOf(
        UrlLocal(
            text = "мобильное приложение для Android",
            url = "https://www.rustore.ru/catalog/app/ru.malygin.schedulePRK",
        )
    )
    private val urlsForTechHelp = emptyList<UrlLocal>()/*listOf(
        UrlLocal(
            text = "свяжитесь с нами.",
            url = "vanya.malygin@vk.com",
        )
    )*/


    val urlPairList = listOf(
        UrlPair(
            text = textForOffSite,
            image = "res/dat_1518416334464.SVG",
            urls = urlsForOffSite
        ),
        UrlPair(
            text = textForMakeBy,
            image = null,
            urls = urlsForMakeBy
        ),
        UrlPair(
            text = textForAndroidApp,
            image = "res/ru_store.png",
            urls = urlsForAndroidApp,
            scale = 0.8,
            important = true
        ),
        UrlPair(
            text = textForTechHelp,
            image = null,
            urls = urlsForTechHelp,
            important = true
        ),
        UrlPair(
            text = textForHosting,
            image = "res/timeweb.webp",
            urls = urlsForHosting,
            scale = 1.0,
            transformOrigin = "bottom".unsafeCast<TransformOrigin>(),
            minHeight = 3.vh
        )
    )


    companion object{
        data class UrlPair(
            val text: String,
            val image: String?,
            val urls: List<UrlLocal>,
            val scale: Double = 1.0,
            val transformOrigin: TransformOrigin = "center".unsafeCast<TransformOrigin>(),
            val important: Boolean = false,
            val minHeight: Length = 14.vh
        )
    }
}

